import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks'; import PageLoader from '../../../../../components/PageLoader';
import GlobalNicCodeComponent from '../components/global-nic-codes.component';
import { selectGlobalPinCodesQueryItems } from '../../../../../redux/global-iship-cloud/global-pin-codes/selector';
import { globalPinCodes } from '../../../../../redux/global-iship-cloud/global-pin-codes/action';
import { globalNicCodes } from '../../../../../redux/global-iship-cloud/global-nic-codes/action';

const GlobalNicCode = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectGlobalPinCodesQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    nicCode,
    setNicCode
  ] = useState<any>({})

  const fetchRecordById = () => {
    dispatch(globalNicCodes.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-nic-codes/fetch-detail`, entity: 'globalNicCodes', jsonData:
      {
        Context: {},
        Records: [
          {
            "GlobalNICcodeId": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  useEffect(
    () => {
      if (parmas?.id > 0) {
        fetchRecordById()
      }
    }, [])

  useEffect(
    () => {
      if (isQuery) {
        setNicCode(queryItems?.result?.items)
      }
    }, [isQuery])

  const handleInnerBasicFormChange: any = (event: any, field: string) => {
    setNicCode({ ...nicCode, [field]: event });
  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

    if (parmas?.id > 0) {
      dispatch(globalNicCodes.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-nic-codes`, entity: 'globalNicCodes', jsonData:
        {
          "Context": {},
          Records: [
            nicCode
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      dispatch(globalNicCodes.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-nic-codes`, entity: 'globalNicCodes', jsonData:
        {
          "Context": {
          },
          Records: [
            nicCode
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = async () => {
    navigate(-1)
  }

  return (
    <>
      {queryItems?.isLoading ? <PageLoader /> :
        <GlobalNicCodeComponent
          nicCode={nicCode}
          handleFormSubmit={handleFormSubmit}
          back={back}
          handleInnerBasicFormChange={handleInnerBasicFormChange}
        />}
    </>
  )

}

export default GlobalNicCode;